import { render, staticRenderFns } from "./SeeHistory.vue?vue&type=template&id=20b49786&scoped=true"
import script from "./SeeHistory.vue?vue&type=script&lang=js"
export * from "./SeeHistory.vue?vue&type=script&lang=js"
import style0 from "./SeeHistory.vue?vue&type=style&index=0&id=20b49786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b49786",
  null
  
)

export default component.exports